
/**
 * A custom hook for implementing smooth scrolling behavior
 * with offset adjustment for fixed header and improved animation
 */
export const useSmoothScroll = () => {
  const scrollToElement = (
    elementId: string, 
    offset: number = 80, 
    duration: number = 400
  ) => {
    console.log(`Smooth scrolling to element with id: ${elementId}`);
    
    // Find the target element
    const targetElement = document.getElementById(elementId);
    
    if (!targetElement) {
      console.warn(`Element with id '${elementId}' not found`);
      return;
    }
    
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime: number | null = null;
    
    console.log(`Target position: ${targetPosition}, Start position: ${startPosition}, Distance: ${distance}`);
    
    // Animation function
    const animation = (currentTime: number) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      
      // Use a more immediate easing function
      const easeOutQuart = (progress: number) => {
        return 1 - Math.pow(1 - progress, 4);
      };
      
      window.scrollTo({
        top: startPosition + distance * easeOutQuart(progress),
        behavior: 'auto' // We're handling the animation manually
      });
      
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      } else {
        console.log(`Scroll animation completed to ${elementId}`);
      }
    };
    
    // Start animation immediately on next frame
    requestAnimationFrame(animation);
  };
  
  // Update the scrollToTop function to be more immediate
  const scrollToTop = (e?: React.MouseEvent | Event, duration: number = 300) => {
    // Prevent default behavior if an event is passed
    if (e) {
      e.preventDefault();
    }
    
    console.log('Smooth scrolling to top');
    
    const startPosition = window.scrollY;
    const targetPosition = 0;
    const distance = targetPosition - startPosition;
    let startTime: number | null = null;
    
    const animation = (currentTime: number) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      
      // Use a more immediate easing function
      const easeOutQuart = (progress: number) => {
        return 1 - Math.pow(1 - progress, 4);
      };
      
      window.scrollTo({
        top: startPosition + distance * easeOutQuart(progress),
        behavior: 'auto'
      });
      
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      } else {
        console.log('Scroll to top animation completed');
      }
    };
    
    // Start animation immediately
    requestAnimationFrame(animation);
  };
  
  return { scrollToElement, scrollToTop };
};
